import type { AppModule } from '../registry';
import { IconLinkedIn } from '../../components/icons';
import { ConnectionsView } from './ConnectionsView';

// Publish app-module (user-scoped; app_code stays 'linkedin' — the registry key + /a/linkedin
// route are unchanged, only the display label is "Publish"). The console surfaces a live,
// read-only connection status board; the connect/disconnect actions (LinkedIn OAuth +
// blog/tracker forms) are bound to publish.captomi.com, so the view links out there to manage.
export const linkedin_module: AppModule = {
  app_code: 'linkedin',
  label: 'Publish',
  blurb: 'Drafts and publishes your content across LinkedIn, blogs, and more — connect your accounts and channels.',
  icon: <IconLinkedIn />,
  accent: '#0a66c2',
  nav: [{ path: 'connections', label: 'Connections', element: <ConnectionsView /> }],
};
